import React, { useState } from 'react';
import { FichaCaptacaoList } from '../components/FichaCaptacaoList';
import { FichaCaptacaoForm } from '../components/FichaCaptacaoForm';
import { FichaCaptacaoView } from '../components/FichaCaptacaoView';
import { FichaCaptacao } from '../types/ficha-captacao';

type ViewMode = 'list' | 'form' | 'view';

const FichasCaptacaoPage: React.FC = () => {
  const [currentView, setCurrentView] = useState<ViewMode>('list');
  const [selectedFicha, setSelectedFicha] = useState<FichaCaptacao | undefined>();

  const handleNew = () => {
    setSelectedFicha(undefined);
    setCurrentView('form');
  };

  const handleEdit = (ficha: FichaCaptacao) => {
    setSelectedFicha(ficha);
    setCurrentView('form');
  };

  const handleView = (ficha: FichaCaptacao) => {
    setSelectedFicha(ficha);
    setCurrentView('view');
  };

  const handleSave = () => {
    setCurrentView('list');
    setSelectedFicha(undefined);
  };

  const handleCancel = () => {
    setCurrentView('list');
    setSelectedFicha(undefined);
  };

  const handleEditFromView = () => {
    setCurrentView('form');
  };

  const handleBackFromView = () => {
    setCurrentView('list');
    setSelectedFicha(undefined);
  };

  return (
    <div className="container mx-auto p-4">
      {currentView === 'list' && (
        <FichaCaptacaoList
          onNew={handleNew}
          onEdit={handleEdit}
          onView={handleView}
        />
      )}

      {currentView === 'form' && (
        <FichaCaptacaoForm
          ficha={selectedFicha}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}

      {currentView === 'view' && selectedFicha && (
        <FichaCaptacaoView
          ficha={selectedFicha}
          onEdit={handleEditFromView}
          onBack={handleBackFromView}
        />
      )}
    </div>
  );
};

export default FichasCaptacaoPage;